import React from 'react';

export default function UseEffect({ func = () => {}, observer = [] }) {
  React.useEffect(func, observer);
  return null;
}
